import moment from "moment";
import i18n from "@/i18n";

const { t, d } = i18n.global;

export function getDuration(startTime: string, endTime: string) {
  if (endTime !== "1900-01-01T00:00:00" && startTime !== "1900-01-01T00:00:00") {
    const startMoment = moment(startTime);
    const endMoment = moment(endTime);

    const duration = moment.duration(endMoment.diff(startMoment));

    const hours = Math.abs(Math.trunc(duration.asHours()));
    const minutes = Math.abs(duration.minutes());
    const seconds = Math.abs(duration.seconds());

    let formattedDuration = "";
    if (hours >= 1) {
      formattedDuration += `${hours} ${t("DateHours")} ${minutes} ${t("DateMinutes")} ${seconds} ${t("DateSeconds")}`;
    } else {
      if (minutes >= 1) {
        formattedDuration += `${minutes} ${t("DateMinutes")} ${seconds} ${t("DateSeconds")}`;
      } else {
        formattedDuration += `${seconds} ${t("DateSeconds")}`;
      }
    }
    return formattedDuration;
  } else {
    return `N/A`;
  }
}

export function getDateTimeText(date: Date | string) {
  const today = moment();
  const relevantDate = moment(date);

  const timeBetweenMillisecondsDuration = moment.duration(today.diff(relevantDate));
  const timeBetweenMinutes = Math.floor(timeBetweenMillisecondsDuration.asMinutes());
  const timeBetweenHours = Math.floor(timeBetweenMillisecondsDuration.asHours());

  if (3 > timeBetweenMinutes) {
    return t("JustNow");
  } else if (60 > timeBetweenMinutes) {
    return t("XMinutesPrior", { count: timeBetweenMinutes });
  } else if (24 > timeBetweenHours) {
    return t("XHoursPrior", { count: timeBetweenHours });
  } else {
    return d(relevantDate.toDate(), "shortDate") + "   " + d(relevantDate.toDate(), "shortTime");
  }
}
